import {
    FETCH_COUNTRY_SHORT_CODE,
    FETCH_COUNTRY_SHORT_CODE_SUCCESS,
    FETCH_COUNTRY_SHORT_CODE_FAILS,
    ASSIGN_COUNTRY_SHORT_CODE,
    FETCH_IPLOCATION_SUCCESS,
    FETCH_IPLOCATION_FAILS
} from './locationActionTypes';

export const appReducer = (
    state = {
        fetching: false,
        coordinates: {
            lat: null,
            lng: null
        },
        error: null
    },
    action
) => {
    switch (action.type) {
        case FETCH_COUNTRY_SHORT_CODE:
            return Object.assign({}, state, { fetching: true });

        case FETCH_COUNTRY_SHORT_CODE_SUCCESS:
            return {
                ...state,
                fetching: false,
                data: { ...action.payload }
            };
        case FETCH_COUNTRY_SHORT_CODE_FAILS:
            return Object.assign({}, { data: [] }, { fetching: false }, { error: { status: true, message: '' } });

        case ASSIGN_COUNTRY_SHORT_CODE:
            return {
                ...state,
                data: { ...action.payload }
            };
        case FETCH_IPLOCATION_SUCCESS:
            if (action.payload?.location) {
            return {
                ...state,
                coordinates: {
                    lat : action.payload?.location?.lat,
                    lng : action.payload?.location?.lng
                },
                error: null
            };
            } else {
                return {
                    ...state,
                    coordinates: action.payload,
                    error: null
                };
            }
            case FETCH_IPLOCATION_FAILS:
                return {
                    ...state,
                    coordinates: {
                        lat: 6.901608599999999, // Sri Lanka latitude
                        lng: 80.0087746 // Sri Lanka longitude
                    },
                    error: action.payload// Store the error message from the action
                };

        default:
            return state;
    }
};
